const features_bugs = {
	bugs: {
		add_dialog: {
			title: "Bug rapporteren",
		},
		report_button: "Rapporteren",
		show_all: "Toon alle bugs",
		title: "Bugs",
	},
	features: {
		add_dialog: {
			inputs: {
				description: "Beschrijving",
				image_added: "Foto geüpload",
				image_delete: "Foto verwijderen",
				image_upload: {
					description:
						"Geaccepteerde formaten: .jpg, .jpeg, .png. </br>Bestand mag niet groter zijn dan 5MB.",
					image_too_large: "De afbeelding mag niet groter zijn dan 5MB.",
					something_wrong: "Er is iets misgegaan. Probeer het later opnieuw.",
					title: "Optioneel: Foto uploaden",
				},
				title: "Titel",
			},
			title: "Feature aanvragen",
		},
		request_button: "Aanvragen",
		show_all: "Toon alle features",
		title: "Features",
	},
	title: "Features & Bugs",
};

export default features_bugs;
